import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/shell/AppShell";
import DestinationLayout from "@/components/shell/DestinationLayout";
import { PLAN_SECTIONS, INSIGHTS_SECTIONS, YOU_SECTIONS } from "@/components/shell/sections";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import Join from "@/pages/Join";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Trips from "@/pages/Trips";
import TripDetail from "@/pages/TripDetail";
import LiveTrip from "@/pages/LiveTrip";
import ManualPaste from "@/pages/ManualPaste";
import Chat from "@/pages/Chat";
import Plan from "@/pages/Plan";
import Planner from "@/pages/Planner";
import PlanWishlist from "@/pages/plan/Wishlist";
import Budget from "@/pages/Budget";
import Act60 from "@/pages/Act60";
import Profile from "@/pages/Profile";
import People from "@/pages/People";
import YouFamily from "@/pages/you/Family";
import YouCalendars from "@/pages/you/Calendars";
import YouNotifications from "@/pages/you/Notifications";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/join" element={<Join />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/terms" element={<Legal doc="terms" />} />

            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/home" element={<Dashboard />} />
              <Route path="/trips" element={<Trips />} />
              <Route path="/trips/:tripId/live" element={<LiveTrip />} />
              <Route path="/trips/:tripId" element={<TripDetail />} />
              <Route path="/manual" element={<ManualPaste />} />

              <Route path="/plan" element={<DestinationLayout items={PLAN_SECTIONS} testId="plan-destination" />}>
                <Route index element={<Navigate to="/plan/ai" replace />} />
                <Route path="ai" element={<Chat />} />
                <Route path="search" element={<Plan />} />
                <Route path="scenarios" element={<Planner />} />
                <Route path="wishlist" element={<PlanWishlist />} />
              </Route>

              <Route path="/insights" element={<DestinationLayout items={INSIGHTS_SECTIONS} testId="insights-destination" />}>
                <Route index element={<Navigate to="/insights/budget" replace />} />
                <Route path="budget" element={<Budget />} />
                <Route path="presence" element={<Act60 />} />
              </Route>

              <Route path="/you" element={<DestinationLayout items={YOU_SECTIONS} testId="you-destination" />}>
                <Route index element={<Navigate to="/you/profile" replace />} />
                <Route path="profile" element={<Profile />} />
                <Route path="people" element={<People />} />
                <Route path="family" element={<YouFamily />} />
                <Route path="calendars" element={<YouCalendars />} />
                <Route path="notifications" element={<YouNotifications />} />
              </Route>

              {/* Legacy redirects — keep every old deep-link alive */}
              <Route path="/dashboard" element={<Navigate to="/home" replace />} />
              <Route path="/chat" element={<Navigate to="/plan/ai" replace />} />
              <Route path="/planner" element={<Navigate to="/plan/scenarios" replace />} />
              <Route path="/budget" element={<Navigate to="/insights/budget" replace />} />
              <Route path="/act60" element={<Navigate to="/insights/presence" replace />} />
              <Route path="/profile" element={<Navigate to="/you/profile" replace />} />
              <Route path="/people" element={<Navigate to="/you/people" replace />} />
              <Route path="/settings" element={<Navigate to="/you/notifications" replace />} />
            </Route>

            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
